import PropTypes from 'prop-types';
import VXButton from '../SimpleElements/VXButton/VXButton';
import { COLOR_TYPE_CALL_TO_ACTION } from '../SimpleElements/VXButton/ButtonHelper';
import { VXButtonLineConfig } from '../SimpleElements/VXButton/VXButtonConfig';
import { getCommonTranslation } from '../../utils/TranslationHelper';
import Translations from './../../utils/Translations';
import { VXPay } from '../../utils/VXPay';
import Flux from '../../flux/Flux';
import { tippingGoalType } from './FeedHelper';

export default function FeedPostNeedAction({ poster, actorId, needAvs, isOverlay = false, showBadge = true, transparent = true, tippingGoal = {} }) {
	const isLoggedIn = Flux.Guest.isLoggedIn();
	const headline = isLoggedIn
		? getCommonTranslation('modal__no-avs__headline')
		: getCommonTranslation(Flux.Browser.isSexole() ? 'modal__need-login__headline--sexole' : 'modal__need-login__headline');
	const text = isLoggedIn ? getCommonTranslation('modal__no-avs__text') : getCommonTranslation('modal__need-login__text');
	const buttonText = isLoggedIn ? Translations.get('AvsTeaserConfirmationButton') : getCommonTranslation('login_or_signup_button').toUpperCase();
	const style = isLoggedIn && !needAvs ? { backgroundImage: `url(${poster})` } : {};
	const options = { host: actorId };

	return (
		<div
			className={
				'modal__picture-no-avs__wrapper feed-avs' +
				(isOverlay ? ' feed-avs--overlay' : '') +
				(tippingGoal && !tippingGoal.achieved ? ' feed-avs--tipping' : '')
			}
			style={style}
		>
			{isLoggedIn && needAvs && <img className="feed-avs__fake" src={poster} />}
			{transparent && <div className="feed-avs-transparent"></div>}
			<span className={'icon -icon-keylock_close modal__picture-no-avs__key h-pos-relative'}>
				{showBadge && <span className="modal__picture-no-avs__badge">{Translations.get('Over18')}</span>}
			</span>
			<div className="modal__picture-no-avs__headline h-pos-relative">{headline}</div>
			<div className="modal__picture-no-avs__text h-pos-relative">{text}</div>
			<div className="modal__picture-no-avs__button h-pos-relative">
				<VXButton
					line1={[new VXButtonLineConfig(buttonText)]}
					icon={isLoggedIn ? '-icon-keylock_open' : null}
					color={COLOR_TYPE_CALL_TO_ACTION}
					onClick={isLoggedIn ? VXPay.openAVS : () => VXPay.openSignupOrLogin(options)}
				/>
			</div>
		</div>
	);
}

FeedPostNeedAction.propTypes = {
	poster: PropTypes.string,
	actorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	needAvs: PropTypes.oneOfType([
		PropTypes.shape({
			avsRequired: PropTypes.bool,
			id: PropTypes.string,
			srcSet: PropTypes.string,
			url: PropTypes.string,
		}),
		PropTypes.bool,
	]),
	isOverlay: PropTypes.bool,
	showBadge: PropTypes.bool,
	transparent: PropTypes.bool,
	tippingGoal: PropTypes.shape(tippingGoalType),
};
